import { render } from "./checkDescrip.vue?vue&type=template&id=0f7d0997&scoped=true&ts=true"
import script from "./checkDescrip.vue?vue&type=script&lang=ts"
export * from "./checkDescrip.vue?vue&type=script&lang=ts"

import "./checkDescrip.vue?vue&type=style&index=0&id=0f7d0997&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7d0997"]])

export default __exports__